export { default } from '../bottomInfo/BottomInfo';
